import { authSlice } from "./auth.slice";
import { configSlice } from "./config.slice";
import { userSlice } from "./user.slice";
import { filterSlice } from "./filter.slice";

export const authActions = authSlice.actions;
export const authReducer = authSlice.reducer;

export const configActions = configSlice.actions;
export const configReducer = configSlice.reducer;

export const userActions = userSlice.actions;
export const userReducer = userSlice.reducer;

export const filterActions = filterSlice.actions;
export const filterReducer = filterSlice.reducer;

